import { Pdfgqr } from '../../../models/pdfgqr.model';
import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';

import { QrService } from '../../../services/qr.service';
import { Qr } from '../../../models/qr.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SafeUrl } from '@angular/platform-browser';
import { QRCodeElementType, FixMeLater, QRCodeModule } from 'angularx-qrcode';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { PdfgenerateqrService } from '../../../services/pdfgenerateqr.service';
import { LogoService, ToastAlertService } from '@core/services';
import { Store } from '@ngrx/store';
import { selectLogo } from '@store/selectors';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@shared/components/button/button.component';
import { NgFor } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { TitleComponent } from '@shared/components/title/title.component';

@Component({
  selector: 'app-qr-list',
  templateUrl: './qr-list.component.html',
  styles: [
    `
      .custom-scroll {
        max-height: 300px; /* Ajusta la altura máxima según tus necesidades */
        overflow-y: auto;
      }
    `,
  ],
  standalone: true,
  imports: [
    TitleComponent,
    MatListModule,
    NgFor,
    ButtonComponent,
    RouterLink,
    QRCodeModule,
    MatDialogClose,
  ],
})
export class QrListComponent implements OnInit {
  private logoService = inject(LogoService);
  private readonly store = inject(Store);
  public readonly logo = this.store.selectSignal(selectLogo);
  private alert = inject(ToastAlertService);

  listOfQR: Qr[] = [];
  currentQR: any;

  private QrService = inject(QrService);
  private http = inject(HttpClient);
  private destroyRef = inject(DestroyRef);

  elementType = 'canvas' as QRCodeElementType;

  qrCodeDownloadLink: SafeUrl = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<QrListComponent>,
    private PdfgenerateqrService: PdfgenerateqrService
  ) {
    console.log('DATOS RECIBIDOS ', data);
    this.dialogRef.disableClose = true;
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  ngOnInit(): void {
    this.loadQRList(this.data);
    this.qrListClose();
  }

  loadQRList(data: any) {
    console.log('Datos', data);
    this.QrService.getQR(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ reply }) => {
          console.log('Reply', reply);
          if (reply.length > 0) {
            this.listOfQR = reply;
            this.currentQR = this.listOfQR[0];
          } else {
            this.alert.error('No se encontraron puestos de trabajo.');
            this.dialogRef.close('cerrar');
          }
        },
        error: () => {
          console.log('No se pudo cargar el login ');
        },
      });
  }

  setCurrentQR(qr: Qr) {
    this.currentQR = qr;
  }

  download(parent: FixMeLater) {
    this.downloadpdf('element-to-capture');
  }
  downloadpdf(captureid: string) {
    const element = document.getElementById(captureid);

    if (element) {
      html2canvas(element).then(canvas => {
        // Captura el contenido del elemento como una imagen

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jspdf.jsPDF();

        // Configura el tamaño del PDF para que coincida con el contenido capturado
        const imgWidth = 210; // Ancho de la página A4 en mm
        const pageHeight = (imgWidth * canvas.height) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, pageHeight);

        // Guarda el PDF como un archivo
        pdf.save('captured-content.pdf');
      });
    } else {
      console.error('Elemento con ID "element-to-capture" no encontrado.');
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(';base64,');
    // hold the content type
    const imageType = parts[0].split(':')[1];
    // decode base64 string
    const decodedData = window.atob(parts[1]);
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType });
  }

  imgsysadmin = '';
  qrListClose() {
    console.log(this.data.logo_id, 'data logo_id');
    this.logoService.getOneLogo(this.data.logo_id).subscribe({
      next: ({ reply }) => {
        console.log(reply, 'lo que me trae logoService');
        this.imgsysadmin = reply.value;
        console.log(this.imgsysadmin, 'imagen en base 64');
      },
    });
  }
  loadImg() {
    let valuelogo = this.logo() && this.logo()[0] && this.logo()[0].value;
    console.log(valuelogo, 'datos que me trae el valuelogo');

    if (!valuelogo) {
      console.log('Entre', this.imgsysadmin);
      valuelogo = this.imgsysadmin;
      console.log(valuelogo, 'entro a la funcion de validar dato');
    }

    const miVariable: Pdfgqr = {
      name: this.currentQR.workplace_name, // Aquí asignamos el valor a la propiedad 'name'
      qrdata: this.currentQR.workplace_id, // Asigna valores a las otras propiedades según tus necesidades
      width: 208, //tamano en QR
      logo: valuelogo,
      type: this.currentQR.type,
    };
    console.log(this.logo, 'valor que se esta mandando en logo');

    // Crear un arreglo que contiene el objeto
    const datos: Pdfgqr[] = [miVariable];

    // Luego, puedes asignar este arreglo al servicio
    const datoServiceInstance = this.PdfgenerateqrService;
    datoServiceInstance.dato = datos;
    // Accede a la propiedad dato
    console.log(datoServiceInstance.dato);

    this.dialogRef.close('cerrar');
  }

  qrlistsend() {
    let valuelogo = this.logo() && this.logo()[0] && this.logo()[0].value;
    console.log(valuelogo, 'datos que me trae el valuelogo');

    if (!valuelogo) {
      console.log('Entre', this.imgsysadmin);
      valuelogo = this.imgsysadmin;
      console.log(valuelogo, 'entro a la funcion de validar dato');
    }
    const datos: Pdfgqr[] = [];

    for (let i = 0; i < this.listOfQR.length; i++) {
      const miVariable: Pdfgqr = {
        name: this.listOfQR[i].workplace_name ?? '', // Aquí asignamos el valor a la propiedad 'name'
        qrdata: this.listOfQR[i].workplace_id?.toString() ?? '',
        width: 208, //tamano en QR
        logo: valuelogo,
        type: 'Puesto',
      };

      datos.push(miVariable);
    }

    // Luego, puedes asignar este arreglo al servicio
    const datoServiceInstance = this.PdfgenerateqrService;
    datoServiceInstance.dato = datos;
    // Accede a la propiedad dato
    console.log(datoServiceInstance.dato);

    this.dialogRef.close('cerrar');
  }
}
